// extracted by mini-css-extract-plugin
export default {"container":"auth_container__6gKEp","title":"auth_title__8YKXo","button":"auth_button__ogPG-","back":"auth_back__EnAIw","disabled":"auth_disabled__Ht1K+"};